import { _js, ___p } from '@ifixit/localize';
import { color, space, fontSize, borderRadius } from '@ifixit/primitives';
import styled from 'styled-components';
import initializeComponent from 'Shared/react-initialize';
import { DocumentMeta, PageReference } from './document_meta_types';
import { DocumentMetaCard, DocumentMetaAccordion } from './document_meta';
import Accordion from './accordion';
import ReferencesAccordion from './references_accordion';

type DocumentMetaViewProps = {
   currentDoc: DocumentMeta;
   prevDocs: DocumentMeta[];
   refs: PageReference[];
};

const Container = styled.div`
   font-style: normal;
   color: ${color.gray[800]};
`;

const Title = styled.h2`
   font-weight: 700;
   font-size: ${fontSize['3xl']};
   line-height: 29px;
   padding-bottom: ${space[2]};
   border-bottom: 1px solid ${color.gray[200]};
   margin: ${space[5]} 0;
   color: ${color.gray[800]};
`;

const DocumentMetaCardWithAccordion = styled(DocumentMetaCard)`
   ${Accordion} {
      border-radius: 0 0 ${borderRadius.md} ${borderRadius.md};
      box-shadow: none;
   }
`;

const RevisionHeader = styled.h3`
   font-weight: 700;
   font-size: ${fontSize.xl};
   line-height: 22px;
   margin: ${space[8]} 0 ${space[4]} 0;
   color: ${color.gray[800]};
`;

const RevisionList = styled.ul`
   margin: 0 0 ${space[11]} 0;
   padding: 0;

   > :not(:first-child) {
      margin-top: ${space[2]};
   }
`;

const DocumentMetaView = ({ currentDoc, refs, prevDocs }: DocumentMetaViewProps) => (
   <Container>
      <Title>{currentDoc.title || _js('Document History')}</Title>
      <DocumentMetaCardWithAccordion doc={currentDoc}>
         <ReferencesAccordion refs={refs} />
      </DocumentMetaCardWithAccordion>
      <RevisionHeader>
         {___p(
            prevDocs.length,
            '%1 Previous Version',
            '%1 Previous Versions',
            String(prevDocs.length)
         )}
      </RevisionHeader>
      <RevisionList>
         {prevDocs.map(rev => (
            <DocumentMetaAccordion key={rev.date} doc={rev} />
         ))}
      </RevisionList>
   </Container>
);

initializeComponent('DocumentMetaView', DocumentMetaView);
